import { z } from 'zod'
import { calendarDateSchema } from '../validators/calendar-date.validator.js'
import { uuidSchema } from '../validators/uuid.validator.js'

/** A recorded request for someone to attend a board meeting. */
export const proposalMeetingRequestDtoSchema = z.object({
  id: uuidSchema,
  /** The day of the meeting, YYYY-MM-DD, as the client picked it. */
  meetingDate: calendarDateSchema,
  note: z.string().nullable(),
  /** Who the proposal was delivered to, when the request came through a link. */
  requestedByEmail: z.string().nullable(),
  createdAt: z.string().datetime(),
})

export type ProposalMeetingRequestDto = z.infer<
  typeof proposalMeetingRequestDtoSchema
>
